import React, { Component } from 'react';
import { styled } from 'linaria/react';
import { RowProducts } from '../../ui/ProductRow/RowProducts';

const RelatedWrapper = styled('div')`
  margin: 3rem 0 2rem 0;
  width: 100%;
  .related-product-grid {
  }
`;

class RelatedProducts extends Component {
  state = {};
  render() {
    const { products } = this.props;
    const category = {
      name: 'Related products',
      products: {
        result: products
      }
    };

    return (
      <RelatedWrapper id="related-products">
        <RowProducts
          category={category}
          slider={true}
          title={'Don´t forget the accessories'}
          subTitle={'Look here'}
          quickBuy={true}
        />
      </RelatedWrapper>
    );
  }
}

export default RelatedProducts;
